<script setup>
import { ref, onMounted } from 'vue';
import { POLICY_URL } from '@/data/links';
import { isCookieConsentGiven, setCookieConsent } from '@/utils/cookieConsent';

const isVisible = ref(false);

const accept = () => {
  isVisible.value = false;
  setCookieConsent();
};

onMounted(() => {
  isVisible.value = !isCookieConsentGiven();
});
</script>

<template>
  <div class="cookie-banner" v-if="isVisible">
    <div class="cookie-banner__inner">
      <div class="cookie-banner__content">
        <h3 class="cookie-banner__title">О файлах cookie на этом веб-сайте</h3>
        <p class="cookie-banner__text">
          Вы даёте согласие на&nbsp;обработку персональных данных, собираемых с&nbsp;использованием файлов cookie,
          а&nbsp;также посредством метрической программы «Яндекс Метрика», в&nbsp;целях профилирования посетителей
          сайта, получения статистических данных о&nbsp;посещении сайта. Если вы&nbsp;не&nbsp;хотите, чтобы ваши
          персональные данные обрабатывались, покиньте сайт. Более подробная информация
          в&nbsp;<a :href="POLICY_URL" target="_blank">Политике обработки файлов cookie</a>.
        </p>
      </div>
      <a href="" class="cookie-banner__button" @click.prevent="accept">Согласен</a>
    </div>
  </div>
</template>
